import AutoSelect from '../AutoSelect';
import Card from '../Card';
import Button from '../Button';

export default function CompetitionStep({
  competitions, selectedCompetition, setSelectedCompetition,
  onNext, setDisplaySuccess, setSelectedDate, selectedDate, dates
}) {
  
  return (
    <Card>
      {competitions.length > 0 ? (
        <div className='w-11/12 xl:w-10/12 2xl:w-8/12 text-black flex flex-col items-center justify-center gap-8 text-black'>
          <h3 className='text-lg font-semibold'>Search for a competition</h3>
          <AutoSelect
            options={competitions}
            value={selectedCompetition}
            setValue={setSelectedCompetition}
            placeholder="Competition"
            label="name"
            multi={false}
          />
          {dates.length > 1 && (
            <AutoSelect
              options={dates}
              value={selectedDate}
              label="name"
              setValue={setSelectedDate}
              setDisplaySuccess={setDisplaySuccess}
              placeholder="Competition Date"
              multi={false}
            />
          )}
          <Button
            onClickMethod={onNext}
            width='9/12'
            mobileWidth='full'
          >
            Continue
          </Button>
        </div>
      ) : <div className='centered-form'><h3>No Competitions Currently Open For Registration</h3></div>}
    </Card>
  );
}